let document_ready = false;

const bundle_sizes = document.querySelectorAll('.js-bundle-size');
const bundle_variant_inputs = document.querySelectorAll('.bundle-product');
const bundle_containers = document.querySelectorAll('.js-bundle__container');

const bundle_data_elem = document.querySelector('#bundle-data');
const data = bundle_data_elem ? JSON.parse(bundle_data_elem.innerHTML) : null;

let current_size =
  bundle_sizes.length > 0
    ? [...bundle_sizes].find(x => x.checked)?.value || null
    : null;

if (!data) throw new Error('No Dataset - Bundle won\'t work');


/* =========================================================
   COLOR HELPERS
========================================================= */

/*
 * Normalize text for fallback matching.
 */
const normalizeColor = (value) => {
  return String(value || '')
    .toLowerCase()
    .replace(/ø/g, 'o')
    .replace(/æ/g, 'ae')
    .replace(/å/g, 'a')
    .replace(/ä/g, 'a')
    .replace(/ö/g, 'o')
    .replace(/\s+/g, ' ')
    .trim();
};


/*
 * Extract the color code from a color string.
 *
 * Examples:
 *
 * Lys kamelbrun meleret (020m) -> 020m
 * Kamelbrun (018)               -> 018
 * Beige (10)                    -> 10
 */
const getColorCode = (value) => {
  const match = String(value || '').match(/\(([^)]+)\)/);

  return match
    ? match[1].trim().toLowerCase()
    : '';
};


/*
 * Remove optional labels from color names.
 */
const cleanColorName = (value) => {
  return String(value || '')
    .replace(
      /vælg\s+garn\s+[a-z]\s*:/gi,
      ''
    )
    .replace(
      /choose\s+yarn\s+[a-z]\s*:/gi,
      ''
    )
    .trim();
};


/*
 * Extract colors from the selected product thumbnail ALT.
 *
 * Example ALT:
 *
 * Laura Sparkle Tee, strikkeopskrift Önling |
 * Lys kamelbrun meleret (020m),
 * Kamelbrun (018),
 * Beige (10)
 *
 * We only use everything after "|".
 */
const extractColorsFromAlt = (altText) => {
  if (!altText) return [];

  const separatorIndex = altText.indexOf('|');

  if (separatorIndex === -1) {
    console.warn(
      'No "|" separator found in thumbnail ALT:',
      altText
    );

    return [];
  }

  const colorPart = altText
    .substring(separatorIndex + 1)
    .trim();

  if (!colorPart) return [];

  return colorPart
    .split(',')
    .map(color => cleanColorName(color))
    .map(color => color.trim())
    .filter(Boolean);
};


/*
 * Get the color/title associated with a bundle input.
 */
const getInputColorName = (input) => {
  if (!input) return '';

  return (
    input.dataset.color ||
    input.dataset.title ||
    input.getAttribute('title') ||
    ''
  );
};


/*
 * Find the exact bundle variant matching a color.
 *
 * IMPORTANT:
 *
 * Availability is deliberately NOT considered.
 *
 * If the correct color is sold out, we still return
 * that exact input instead of selecting another color.
 */
const findBundleInputByColor = (
  bundleIndex,
  colorName
) => {

  const selector =
    `.bundle-product[name="bundle-${bundleIndex}"]`;

  const inputs = [
    ...document.querySelectorAll(selector)
  ];

  if (!inputs.length) {
    return null;
  }


  /*
   * -------------------------------------------------------
   * 1. Match by exact color code first.
   * -------------------------------------------------------
   *
   * Example:
   *
   * ALT:
   * Kamelbrun (018)
   *
   * Match:
   * Kamelbrun (018)
   */
  const wantedCode =
    getColorCode(colorName);

  if (wantedCode) {

    const codeMatch = inputs.find(input => {

      const inputTitle =
        getInputColorName(input);

      const inputCode =
        getColorCode(inputTitle);

      return inputCode === wantedCode;
    });

    if (codeMatch) {
      return codeMatch;
    }
  }


  /*
   * -------------------------------------------------------
   * 2. Fallback to normalized color-name matching.
   * -------------------------------------------------------
   */
  const wanted =
    normalizeColor(
      cleanColorName(colorName)
    );

  if (!wanted) {
    return null;
  }


  return inputs.find(input => {

    const inputTitle =
      getInputColorName(input);

    const inputColor =
      normalizeColor(
        cleanColorName(inputTitle)
      );

    return (
      inputColor === wanted ||
      inputColor.includes(wanted) ||
      wanted.includes(inputColor)
    );

  }) || null;
};


/* =========================================================
   UPDATE BUNDLE SLOT UI

   Single source of truth for syncing the bundle-container
   preview (title / subtitle / image / sold-out state) to
   whichever input is checked for that bundle slot.

   Called from:
     - the shared 'change' listener (real user clicks)
     - applyThumbnailColors (auto-selection from thumbnails)
     - the init routine on page load
========================================================= */

const updateBundleSlotUI = (
  bundleIndex,
  input
) => {

  if (!input) return;


  const container =
    document.getElementById(
      `bundle-container-${bundleIndex}`
    );

  if (!container) return;


  const titleElem =
    container.querySelector(
      '.js-bundle-variant-title'
    );


  const subTitleElem =
    container.querySelector(
      '.js-bundle-variant-subtitle'
    );


  const imgElem =
    container.querySelector('img');

  const imgElemt = container.querySelector('.bundle-container-left-part-img');


  const title =
    input.getAttribute('title') ||
    input.dataset.title ||
    '';


  const lastPart =
    title
      .split('-')
      .pop()
      .trim();


  const sizeObj =
    data.bundleProducts[bundleIndex]
      ?.sizes
      ?.find(
        x => x.size == current_size
      );


  const quantity =
    sizeObj
      ? sizeObj.value
      : 1;


  if (titleElem) {
    titleElem.innerHTML = lastPart;
  }


  if (subTitleElem) {
    subTitleElem.innerHTML =
      `${quantity} ${theme.strings?.pcs ?? 'pcs'}`;
  }


  /*
   * Update bundle preview image.
   */
  const variantContainer =
    input.closest(
      '.js-bundle__variant'
    );


  const variantImg =
    variantContainer?.querySelector('img');


  if (
    imgElem &&
    variantImg?.src
  ) {

    imgElem.src =
      variantImg.src;

  }

  const isSoldOut =
    input.disabled ||
    input.hasAttribute('disabled');

  if (imgElemt) {
    imgElemt.classList.toggle(
      'disabled',
      isSoldOut
    );
  }
};


/* =========================================================
   APPLY COLORS FROM PRODUCT THUMBNAIL

   Canonical implementation — called from the thumbnail
   click listener below. Sets .checked and dispatches a
   real 'change' event so the shared 'change' listener
   (and anything else in the theme listening for it) runs
   exactly as if the user had clicked the swatch directly.
========================================================= */

const applyThumbnailColors = (
  thumbnail
) => {

  if (!thumbnail) return;


  const image =
    thumbnail.querySelector('img');


  if (!image) {
    console.warn(
      'No image found inside .product__thumb-item'
    );

    return;
  }


  const altText =
    image.getAttribute('alt') || '';


  if (!altText.trim()) {
    console.warn(
      'Thumbnail image does not have ALT text.'
    );

    return;
  }


  if (!altText.includes('|')) {
    console.log(
      'Thumbnail ALT does not contain bundle color data:',
      altText
    );

    return;
  }


  console.log(
    'Selected thumbnail ALT:',
    altText
  );


  const colors =
    extractColorsFromAlt(
      altText
    );


  if (!colors.length) {
    console.warn(
      'No colors found in thumbnail ALT.'
    );

    return;
  }


  console.log(
    'Colors extracted from thumbnail:',
    colors
  );


  /*
   * Sanity check: the ALT text must list exactly as many
   * colors as there are bundle slots, in the same order.
   * A mismatch here means one specific thumbnail's ALT
   * text is malformed — it will look like "colors don't
   * update" only for that thumbnail.
   */
  if (colors.length !== data.bundleProducts.length) {
    console.warn(
      `Thumbnail ALT lists ${colors.length} color(s) but there are ` +
      `${data.bundleProducts.length} bundle slot(s). Extra/missing ` +
      'colors will be ignored. ALT:',
      altText
    );
  }


  /*
   * Match each ALT color to the corresponding
   * bundle position.
   */
  colors.forEach(
    (colorName, bundleIndex) => {

      if (bundleIndex >= data.bundleProducts.length) {
        return;
      }


      const input =
        findBundleInputByColor(
          bundleIndex,
          colorName
        );


      if (!input) {

        console.warn(
          `Could not find Bundle ${bundleIndex + 1} color:`,
          colorName
        );

        return;
      }


      console.log(
        `Bundle ${bundleIndex + 1}:`,
        colorName,
        '→',
        getInputColorName(input),
        'sold out:',
        input.disabled
      );


      /*
       * IMPORTANT:
       *
       * Select the exact matching color even if
       * the variant is sold out/disabled.
       *
       * We intentionally do NOT skip disabled inputs.
       */
      input.checked = true;


      /*
       * Setting .checked programmatically does NOT fire a
       * native 'change' event. Dispatch one so the shared
       * 'change' listener (and any other theme code bound
       * to it, e.g. swatch "selected" styling) runs.
       */
      input.dispatchEvent(
        new Event('change', { bubbles: true })
      );

    }
  );


  /*
   * Recalculate price (the change listener above already
   * does this per-input, but a final pass keeps totals
   * consistent if any bundle slot failed to match).
   */
  updateHtmlPrice();


  /*
   * Keep existing cart/bundle data synchronized.
   */
  if (
    typeof updateCartItemsWindowArr ===
    'function'
  ) {

    updateCartItemsWindowArr(
      () => {

        window.bundle =
          getFormData();

      }
    );

  }
};


/* =========================================================
   CURRENT SIZE
========================================================= */

const updateCurrentSize = (
  value
) => {

  current_size = value;


  document
    .querySelectorAll(
      '.js-bundle-current-size'
    )
    .forEach(elem => {

      elem.innerHTML =
        current_size;

    });
};


const updateAllSubtitles = () => {

  data.bundleProducts.forEach(
    (bundle_product, index) => {

      const sizeObj =
        bundle_product.sizes.find(
          x => x.size == current_size
        );


      const quantity =
        sizeObj
          ? sizeObj.value
          : 0;


      const container =
        document.getElementById(
          `bundle-container-${index}`
        );


      const subTitleElem =
        container?.querySelector(
          '.js-bundle-variant-subtitle'
        );


      if (subTitleElem) {

        subTitleElem.innerHTML =
          `${quantity} ${theme.strings?.pcs ?? 'pcs'}`;

      }

    }
  );
};


/* =========================================================
   GET FORM DATA
========================================================= */

const getFormData = () => {

  const bundleId =
    Date.now();


  const bundleTitle =
    document
      .querySelector(
        '.product-single__title'
      )
      ?.textContent
      ?.trim() || '';


  const selectedProducts = [];


  /*
   * Gather selected bundle products.
   */
  data.bundleProducts.forEach(
    (bundle_product, i) => {

      const input =
        document.querySelector(
          `.bundle-product[name="bundle-${i}"]:checked`
        );


      if (!input) return;


      const id =
        String(input.value);


      const sizeObj =
        bundle_product.sizes.find(
          x => x.size == current_size
        );


      const quantity =
        sizeObj
          ? sizeObj.value
          : 1;


      const title =
        input.getAttribute('title') ||
        input.dataset.title ||
        bundle_product.title ||
        'Unnamed Product';


      const item = {

        id,

        quantity:
          Number(quantity),

        title,

        properties: {

          Kit:
            `${bundleTitle} - ${current_size}`,

          _size:
            current_size,

          _productTitle:
            title,

          _bundleId:
            String(bundleId)

        }

      };


      /*
       * Include metafields if any.
       */
      const variant =
        bundle_product.variants.find(
          v =>
            String(v.id) === id
        );


      if (
        variant?.metafields?.contents
      ) {

        item.properties[
          window.theme.strings.kitContent ??
          'Hverdagskit'
        ] =
          variant.metafields.contents;

      }


      selectedProducts.push(
        item
      );

    }
  );


  /*
   * Deduplicate while preserving order.
   */
  const uniqueItemsMap =
    new Map();


  selectedProducts.forEach(
    item => {

      if (
        uniqueItemsMap.has(
          item.id
        )
      ) {

        uniqueItemsMap
          .get(item.id)
          .quantity +=
          item.quantity;

      } else {

        uniqueItemsMap.set(
          item.id,
          {
            ...item
          }
        );

      }

    }
  );


  const bundleItems =
    Array.from(
      uniqueItemsMap.values()
    );


  /*
   * Build _bundleProducts summary.
   */
  const bundleProductsSummary =
    bundleItems.map(
      (item, i) => {

        return (
          `Bundle Product ${i + 1}: ` +
          `${item.title} x ${item.quantity}`
        );

      }
    );


  /*
   * Create master product.
   */
  let masterItem = null;


  if (data.masterProduct) {

    masterItem = {

      id:
        String(
          data.masterProduct
            .variants[0]
            .id
        ),

      quantity: 1,

      properties: {

        Kit:
          `${bundleTitle} - ${current_size}`,

        _size:
          current_size,

        _bundleId:
          String(bundleId),

        _bundlePatternUrl:
          `/products/${data.masterProduct.handle}`,

        _bundleUrl:
          String(window.location.href),

        _bundleProducts:
          bundleProductsSummary.join(
            '\n'
          ),

        _bundleMaster:
          'true'

      }

    };

  }


  /*
   * Final items array.
   */
  const items =
    masterItem
      ? [
          ...bundleItems,
          masterItem
        ]
      : [
          ...bundleItems
        ];


  console.log(
    'Bundle Form Data:',
    {
      items
    }
  );


  return {
    items
  };
};


/* =========================================================
   UPDATE HTML PRICE
========================================================= */

const updateHtmlPrice = () => {

  let total_price =
    data.masterProduct
      ? data.masterProduct.price
      : 0;


  let total_compare_at_price =
    data.masterProduct
      ? (
          data.masterProduct.compare_at_price ||
          data.masterProduct.price
        )
      : 0;


  data.bundleProducts.forEach(
    (bundle_product, index) => {

      /*
       * NOTE: this must be an EXACT name match. Using
       * name^="bundle-${index}" (starts-with) would also
       * match e.g. "bundle-10", "bundle-11" ... when
       * index is 1, picking up the wrong bundle slot's
       * checked input once there are 10+ slots.
       */
      const input =
        document.querySelector(
          `.bundle-product[name="bundle-${index}"]:checked`
        );


      if (!input) return;


      const sizeObj =
        bundle_product.sizes.find(
          x => x.size == current_size
        );


      const quantity =
        sizeObj
          ? sizeObj.value
          : 1;


      const price =
        parseFloat(
          input.dataset.price
        ) || 0;


      const comparePrice =
        parseFloat(
          input.dataset.compareAtPrice
        ) || price;


      total_price +=
        price * quantity;


      total_compare_at_price +=
        comparePrice * quantity;

    }
  );


  const bundle_price_elem =
    document.querySelectorAll(
      '[data-bundle-price]'
    );


  const bundle_compare_at_price_elem =
    document.querySelector(
      '[data-price-wrapper]'
    );


  bundle_price_elem.forEach(
    elem => {

      elem.innerHTML =
        theme.Currency.formatMoney(
          total_price,
          theme.settings.moneyFormat
        );

    }
  );


  if (
    bundle_compare_at_price_elem
  ) {

    if (
      total_compare_at_price >
      total_price
    ) {

      bundle_compare_at_price_elem
        .classList
        .remove('hide');


      const compare_at_price_html = `
        <span class="product__price product__price--compare vb">
          ${theme.Currency.formatMoney(
            total_compare_at_price,
            theme.settings.moneyFormat
          )}
        </span>
      `;


      bundle_compare_at_price_elem.innerHTML =
        compare_at_price_html;


    } else {

      bundle_compare_at_price_elem
        .classList
        .add('hide');

    }

  }


  if (document_ready) {

    window.bundle =
      getFormData();

  }
};


/* =========================================================
   BUNDLE PRODUCT SWATCH CHANGE

   Single shared handler for every ".bundle-product" radio
   change — whether it came from a real user click, from
   applyThumbnailColors(), or from the init routine below.
========================================================= */

document.addEventListener(
  'change',
  (event) => {

    const input =
      event.target;


    if (
      !input.classList.contains(
        'bundle-product'
      )
    ) {
      return;
    }


    const bundleIndex =
      input.name.split('-')[1];


    console.log(
      'Bundle swatch changed:',
      bundleIndex,
      getInputColorName(input)
    );


    updateBundleSlotUI(
      bundleIndex,
      input
    );


    /*
     * Close bundle drawer if open.
     */
    const drawer =
      document.getElementById(
        `BundleDrawer-${bundleIndex}`
      );


    if (
      drawer?.classList.contains(
        'bundle-drawer--is-open'
      )
    ) {

      drawer.classList.remove(
        'bundle-drawer--is-open'
      );


      document
        .querySelector('html')
        .classList.remove(
          'js-drawer-open'
        );


      const overlay =
        document.querySelector(
          '.bundle-drawer-overlay'
        );


      if (overlay) {

        overlay.style.display =
          'none';

      }

    }


    updateHtmlPrice();

  }
);


/* =========================================================
   PRODUCT THUMBNAIL CLICK
========================================================= */

/*
 * Actual thumbnail structure:
 *
 * <div class="product__thumb-item">
 *   <img
 *     alt="Product | Color 1, Color 2, Color 3"
 *   >
 * </div>
 *
 * We detect the parent .product__thumb-item,
 * then read the ALT from its child image.
 */
document.addEventListener(
  'click',
  (event) => {

    const thumbnail =
      event.target.closest(
        '.product__thumb-item'
      );


    /*
     * Ignore clicks that are not on product thumbnails.
     */
    if (!thumbnail) {
      return;
    }


    const image =
      thumbnail.querySelector('img');


    if (!image) {
      return;
    }


    const altText =
      image.getAttribute('alt') || '';


    /*
     * ALT must contain "|" because everything after
     * "|" represents the yarn/color combination.
     */
    if (
      !altText.includes('|')
    ) {

      console.log(
        'No bundle color data found in thumbnail ALT:',
        altText
      );

      return;
    }


    console.log(
      'Clicked product thumbnail:',
      thumbnail
    );


    /*
     * Wait one tick so the product gallery has time
     * to update its selected state/classes.
     *
     * We don't depend on is-selected for detection —
     * applyThumbnailColors() re-reads the ALT itself.
     */
    setTimeout(
      () => {

        applyThumbnailColors(
          thumbnail
        );

      },
      0
    );

  }
);


/* =========================================================
   SIZE CHANGE
========================================================= */

bundle_sizes.forEach(
  input => {

    input.addEventListener(
      'change',
      () => {

        updateCurrentSize(
          input.value
        );


        updateHtmlPrice();


        updateAllSubtitles();

      }
    );

  }
);


/* =========================================================
   INITIALIZE BUNDLE
========================================================= */

window.addEventListener(
  'load',
  () => {

    let attempts = 0;

    const maxAttempts = 20;


    const tryInitBundle = () => {

      attempts++;


      if (
        !document.querySelector(
          '.bundle-product'
        )
      ) {

        if (
          attempts < maxAttempts
        ) {

          setTimeout(
            tryInitBundle,
            200
          );

        }

        return;
      }


      document
        .querySelector(
          '.bundle__section'
        )
        ?.classList
        .remove(
          'loading'
        );


      document_ready =
        true;


      /*
       * Initialize current size.
       */
      const checkedSize =
        [...bundle_sizes]
          .find(
            x => x.checked
          );


      if (checkedSize) {

        updateCurrentSize(
          checkedSize.value
        );

      }


      /*
       * Initialize bundle variants.
       */
      data.bundleProducts.forEach(
        (bundle_product, index) => {

          const selector =
            `.bundle-product[name="bundle-${index}"]`;


          let checkedVariant =
            document.querySelector(
              `${selector}:checked`
            );


          /*
           * Preserve your original behavior:
           * if nothing is selected, select the
           * first variant.
           */
          if (
            !checkedVariant
          ) {

            const firstVariant =
              document.querySelector(
                selector
              );


            if (firstVariant) {

              firstVariant.checked =
                true;


              firstVariant.dispatchEvent(
                new Event(
                  'change',
                  {
                    bubbles: true
                  }
                )
              );


              checkedVariant =
                firstVariant;

            }

          }


          if (!checkedVariant) {
            return;
          }


          /*
           * Sync the preview UI to whichever variant
           * ended up checked (covers both the
           * already-checked case, where no 'change'
           * event fired, and the just-selected case).
           */
          updateBundleSlotUI(
            index,
            checkedVariant
          );

        }
      );


      /*
       * Keep existing cart integration.
       */
      updateCartItemsWindowArr(
        () => {

          window.bundle =
            getFormData();

        }
      );

    };


    /*
     * Existing delayed initialization.
     */
    setTimeout(
      tryInitBundle,
      300
    );


    updateHtmlPrice();

  }
);